import { stores } from '../translations';
import { fromTimeStampFull } from '../utils/helpers/helpers';

/** Миллисекунд в одном дне (для перевода разницы дат в дни) */
export const MS_PER_DAY = 1000 * 60 * 60 * 24;

/** Количество дней, в течение которых нельзя сменить страну повторно в ME */
export const COUNTRY_CHANGE_COOLDOWN_DAYS_ME = 30;

export const getCountryNames = (t) => ({
  [stores.ae]: t('selectModalCountry.countries.uae'),
  [stores.sa]: t('selectModalCountry.countries.saudiArabia'),
  [stores.qa]: t('selectModalCountry.countries.qatar'),
});

export const getCountryChangeAvailableDate = (userCountryUpdated) => {
  if (!userCountryUpdated) {
    return null;
  }

  return new Date(userCountryUpdated * 1000 + COUNTRY_CHANGE_COOLDOWN_DAYS_ME * MS_PER_DAY);
};

export const formatCountryChangeAvailableDate = (userCountryUpdated, language) => {
  const nextChangeDate = getCountryChangeAvailableDate(userCountryUpdated);

  if (!nextChangeDate) {
    return '';
  }

  return fromTimeStampFull(nextChangeDate.getTime() / 1000, language === 'ar');
};

export const canChangeCountry = (profile) => {
  if (!profile?.userCountry || !profile?.userCountryUpdated) {
    return true;
  }

  const nextChangeDate = getCountryChangeAvailableDate(profile.userCountryUpdated);

  return !nextChangeDate || Date.now() >= nextChangeDate.getTime();
};

export const getSelectCountryModalProps = ({ t, profile, language }) => {
  const isCountrySelected = Boolean(profile?.userCountry);
  const variant = isCountrySelected ? 'selectedCountry' : 'nonSelectedCountry';
  const nextChangeDate = formatCountryChangeAvailableDate(profile?.userCountryUpdated, language);

  return {
    title: t(`selectModalCountry.title.${variant}`),
    description: t(`selectModalCountry.description.${variant}`, nextChangeDate ? { value: nextChangeDate } : {}),
  };
};
